export const isConsonant = (letter: string): boolean => {
  const consonants = ['ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ', 'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'];
  return consonants.includes(letter);
};

export const isVowel = (letter: string): boolean => {
  const vowels = ['ㅏ', 'ㅐ', 'ㅑ', 'ㅒ', 'ㅓ', 'ㅔ', 'ㅕ', 'ㅖ', 'ㅗ', 'ㅘ', 'ㅙ', 'ㅚ', 'ㅛ', 'ㅜ', 'ㅝ', 'ㅞ', 'ㅟ', 'ㅠ', 'ㅡ', 'ㅢ', 'ㅣ'];
  return vowels.includes(letter);
};

export const isCompleteKoreanCharacter = (char: string): boolean => {
  const code = char.charCodeAt(0);
  // 한글 완성형 글자의 유니코드 범위: U+AC00 (44032) ~ U+D7A3 (55203)
  return code >= 0xac00 && code <= 0xd7a3;
};
